import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=2a808d11&scoped=true"
import script from "./drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./drawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./drawer.vue?vue&type=style&index=0&id=2a808d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a808d11",
  null
  
)

export default component.exports